import { showNotificationDialog } from '@juvare/alert-ui/ui/features/alerts';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export function showNotificationDialogWithRecipients(t, internalRecipients) {
    showNotificationDialog({
        mode: 'notification',
        reviewFormHeader: t('table.credentialingVerification.actions.notifyDialog.reviewAndSend'),
        wizardHeader: t('table.credentialingVerification.actions.notifyDialog.createNotification'),
        onSubmitSuccess: (_data, onClose) => {
            showAlertSnackbar({
                message: t('table.credentialingVerification.actions.notifyDialog.notificationSent'),
                type: 'success',
                autoHideDuration: 1000,
            });
            onClose();
        },
        partialAlert: { recipients: { internal: internalRecipients } },
    });
}
